module.exports = __webpack_public_path__ + "site/img/team_sub_title_big_3.a9027395.svg";